module.exports = __webpack_public_path__ + "img/weixin1.8cbcb27c.png";